import RencamSchedeMorteCaricamentoCsvList from "./pages/RencamSchedeMorteCaricamentoCsvList";
import RencamSchedeMorteCaricamentoCsvDetailsList from "./pages/RencamSchedeMorteCaricamentoCsvDetailsList";
export default {
    RencamSchedeMorteCaricamentoCsvList,
    RencamSchedeMorteCaricamentoCsvDetailsList,
};
